import React from "react";
import CustomNavbar from "../components/CustomNavbar";
import HeroSection from "../components/HeroSection";
import ServicesSection from "../components/ServicesSection";
import TechnologySection from "../components/TechnologySection";
import IndustriesSection from "../components/IndustriesSection";
import WhyChooseUs from "../components/WhyChooseUs";
import Footer from "../components/Footer";
// import StatsSection from "../components/StatsSection";

function Home() {
  return (
    <>
      <CustomNavbar />
      <HeroSection />
      {/* <StatsSection /> */}
      <ServicesSection />
      <TechnologySection />
      <IndustriesSection />
      <WhyChooseUs />
      <Footer />
    </>
  );
}

export default Home;